import http from '@/utils/http/http'
// 双创载体（暂时不调）
// 金融服务机构(无)

// 产品类型、需求类型、融资产品类型、应用领域获取(用户中心-多级联动)
export function getServiceTypes(data) {
    return http.get('/dataconfig/multistage/list', data, {form: false})
}

// 产品列表 { page, limit }
export function getIncubateProducts(data) {
    return http.get('/incubateApi/webReflect/productsPage', data, {form: false})
}

// 查看产品详情 id
export function getIncubateProductInfo(data) {
    return http.get('/incubateApi/webReflect/productsInfo', data, {form: false})
}

// 需求列表 { page, limit }
export function getDemandApplies(data) {
    return http.get('/incubateApi/webReflect/demandApplyPage', data, {form: false})
}

// 服务记录 { productIdApplied, applyType }
export function getServiceRecode(data) {
    return http.post('/incubateApi/webReflect/getServiceRecode', data, {form: false})
}

// 评价记录 { productId, applyType， type }
export function getEvaluateByProductInfo(data) {
    return http.post('/incubateApi/webReflect/getEvaluateByProductInfo', data, {form: false})
}

// 附件 { productId, applyType， type }
export function getAffixInfo(data) {
    return http.post('/incubateApi/webReflect/getAffixInfo', data, {form: false})
}


// 查看需求详情 id
export function getIncubateDemandInfo(data) {
    return http.get('/incubateApi/webReflect/demandApplyInfo', data, {form: false})
}

// 融资产品详情 : 转贷资金 | 宁科贷业务 | 融资租赁补贴   id
export function getIncubateCostDetail(data) {
    return http.get('/incubateApi/webReflect/costInfo', data, {form: false})
}

// 产业科技创新服务  成果
export function getTecProducts(data) {
    return http.get('/technologyApi/webReflect/productsPage', data, {form: false})
}

// 成果详情 id
export function getTecProductDetail(data) {
    return http.get('/technologyApi/webReflect/productsInfo', data, {form: false})
}

// 产业科技创新服务 需求
export function getTecDemandApply(data) {
    return http.get('/technologyApi/webReflect/demandApplyPage', data, {form: false})
}

// 产业科技创新服务 需求详情
export function getTecDemandApplyDetail(data) {
    return http.get('/technologyApi/webReflect/demandApplyInfo', data, {form: false})
}


// 获取融资产品列表  {costTypeCode, compName}
export function costInfoPage(data) {
    return http.get('/incubateApi/webReflect/costInfoPage', data, {form: false})
}

// 获取按金融机构分组的产品列表  {costTypeCode}
export function costInfoPageGroup(data) {
    return http.get('/incubateApi/webReflect/costInfoPageGroup', data, {form: false})
}

// 活动列表  {}
export function getActivities(data) {
    return http.get('/innovationApi/webReflect/auditPassPage', data, {form: false})
}

// 人才服务  {}
export function getTalent(data) {
    return http.get('/innovationApi/webReflect/talentListPage', data, {form: false})
}
// 登录 获取key
export function getCaptcha() {
    return http.get('/sys/auth/captcha', {}, {form: false})
}

// 登录 {username,password,key, captcha}
export function doLogin(data) {
    return http.get('/sys/auth/login', data, {form: false})
}

/* 其他查询参数获取,如所处阶段、成果种类、成果需求种类等(用户中心-数据字典)
”product_type”:	成果种类(科技创新服务系统)
”stage”:			成果所处阶段(科技创新服务系统)
”apply_type”:		成果需求种类(科技创新服务系统)
”stage_apply”:		成果需求所处阶段(科技创新服务系统)
*/
export function getParams(dictType) {
    return http.get(`/sys/dict/data/dataList/${dictType}`, {}, {form: false})

}

// 获取全部字典列表
export function getParamsAll() {
    return http.get(`/sys/dict/type/all`, {}, {form: false})
}


export function getUserInfo() {
    return http.get(`/sys/user/info`, {}, {form: false, auth: true})
}

export function getTalentInfoById(id) {
    return http.get(`/innovationApi/webReflect/serviceInfo/${id}`, {}, {form: false, auth: true})
}

export function serviceActivityApplicant(data) {
    return http.post(`/innovationApi/webReflect/serviceApplication`, data, {form: false, auth: false})
}